import { library } from "@fortawesome/fontawesome-svg-core";
import { faWordpress } from "@fortawesome/free-brands-svg-icons";
import {
  faBars,
  faTimes,
  faSearch,
  faEdit,
  faChevronLeft,
  faChevronRight,
  faArrowRight,
  faPlus,
  faSignOutAlt,
  faHome,
  faCalendarAlt,
  faMapMarker,
  faUsers,
  faLink,
  faArrowDown91,
  faArrowDownAZ,
} from "@fortawesome/free-solid-svg-icons";

library.add(faWordpress);

library.add(faBars);
library.add(faTimes);
library.add(faSearch);
library.add(faEdit);
library.add(faChevronRight);
library.add(faChevronLeft);
library.add(faPlus);
library.add(faSignOutAlt);
library.add(faHome);
library.add(faCalendarAlt);
library.add(faMapMarker);
library.add(faUsers);
library.add(faLink);
library.add(faArrowRight);
library.add(faArrowDown91);
library.add(faArrowDownAZ);
